import React from 'react';
import { Box } from '@mui/material';

const TriangleBackground = ({ colors, renderWidth = 210 }) => {
  // Extract primary color from design, with fallback
  const primaryColor = colors?.primary || '#f7dc6f';
  
  const height = 297; // A4 height in mm

  // If no colors provided, don't render
  if (!colors) {
    console.warn('TriangleBackground: No colors received. Rendering nothing.');
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    >
      <svg 
        width="100%" 
        height="100%" 
        viewBox={`0 0 ${renderWidth} ${height}`}
        preserveAspectRatio="xMidYMid slice"
        style={{ display: 'block' }}
      >
        {/* Smaller triangle at top center with rounded peak */}
        <path
          d={`M ${renderWidth * 0.4} 0 
              L ${renderWidth * 0.6} 0 
              Q ${renderWidth * 0.52} ${height * 0.12} ${renderWidth * 0.5} ${height * 0.14}
              Q ${renderWidth * 0.48} ${height * 0.12} ${renderWidth * 0.4} 0 Z`}
          fill={primaryColor}
          opacity="0.6"
        />
        
        {/* Smaller triangle at bottom center (inverted) with rounded peak and less opacity */}
        <path
          d={`M ${renderWidth * 0.4} ${height} 
              L ${renderWidth * 0.6} ${height} 
              Q ${renderWidth * 0.52} ${height * 0.88} ${renderWidth * 0.5} ${height * 0.86}
              Q ${renderWidth * 0.48} ${height * 0.88} ${renderWidth * 0.4} ${height} Z`}
          fill={primaryColor}
          opacity="0.3"
        />
      </svg>
    </Box>
  );
};

export default TriangleBackground; 